module.exports = __webpack_public_path__ + "media/images/costumes/costumes-top-main-image-f6c4d8b0f5a84405e934e65eb9c924a4.jpg";